import { useProvider, useQueryClient, useSigner, WagmiConfig } from 'wagmi';

import { ConnectKitProvider } from 'connectkit';

import { ThirdwebSDKProvider } from '@thirdweb-dev/react';
import { wagmiClient } from './web3/connect';
// import '@rainbow-me/rainbowkit/styles.css';

import App from './Routes';

const Main = () => {
  // const { data: signer } = useSigner();
  // const provider = useProvider();
  // const query = useQueryClient();
  console.log('ppp');

  return (
    <WagmiConfig client={wagmiClient}>
      {/* <RainbowKitProvider chains={chains}> */}
      {/* <ThirdwebProvider desiredChainId={ChainId.Mumbai}> */}

      <ConnectKitProvider>
        {/* <ThirdwebSDKProvider
          desiredChainId={80001}
          provider={provider}
          signer={signer as any}
          queryClient={wagmiClient.queryClient as any}
        > */}
        <App />
        {/* </ThirdwebSDKProvider> */}
      </ConnectKitProvider>

      {/* </ThirdwebProvider> */}
      {/* </RainbowKitProvider> */}
    </WagmiConfig>
  );
};

export default Main;
